import { trpc } from '@/shared/api';

interface UseMeQueryOptions {
  readonly enabled?: boolean;
}

/** 내 계정 조회(users.me) — 로그인 여부에 따라 enabled 로 지연시킬 수 있다. */
export const useMeQuery = (options?: UseMeQueryOptions) =>
  trpc.users.me.useQuery(undefined, options);
